import CIMSSelect from 'components/CIMSSelect'
import CIMSFormItem from 'components/CIMSFormItem'
import { HelpMessage } from 'utils/constants'
import { useSubmittalTrackerContext } from '../../../../../../SubmittalTrackerContext'

export const DispositionSelector: React.VFC = () => {
  return (
    <CIMSFormItem
      name="dispositionType"
      label="Disposition"
      requiredMessage="Please select a disposition"
      help={HelpMessage.CAS.SubmittalTracker.Disposition}
    >
      <CIMSSelect
        options={useSubmittalTrackerContext().selectOptions.dispositionOptions}
      />
    </CIMSFormItem>
  )
}
